import { Animated, Easing } from 'react-native';

import { height } from '@utils';

export const DEFAULT_ANIMATION = {
  animateInConfig: {
    easing: Easing.inOut(Easing.exp),
    duration: 300,
  },
  animateOutConfig: {
    easing: Easing.inOut(Easing.exp),
    duration: 300,
  },
  transitionOptions: (animatedValue: Animated.Value) => ({
    transform: [
      {
        translateY: animatedValue.interpolate({
          inputRange: [0, 1, 2],
          outputRange: [height, 0, height],
        }),
      },
    ],
  }),
};
